"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RefugeStory() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const milestones = [{
    year: "1976",
    label: "Refuge Established"
  }, {
    year: "1992",
    label: "Habitat Restoration"
  }, {
    year: "2015",
    label: "Public Outreach"
  }, {
    year: "2024",
    label: "Wildlife Advocacy"
  }];
  return <section data-section-id="789" id="the-story-of-our-refuges" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-[180px]">
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs uppercase tracking-[0.3em] text-primary" style={{
          color: "var(--primary)"
        }}>
            — Our History
          </p>
          <h2 className="mt-8 font-default text-3xl italic leading-[1.15] text-foreground sm:text-4xl md:text-5xl lg:text-[4rem] lg:leading-[1.1]" style={{
          fontFamily: "var(--font-default)"
        }}>
            Born from the quiet
            <br />
            shores of the Pacific,
            <br />
            dedicated to the
            <br />
            wildlife we protect.
          </h2>
          <div className="mx-auto mt-10 h-16 w-px" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
        </div>

        
        <div ref={contentRef} className={`mt-20 grid grid-cols-1 gap-12 transition-all duration-1000 ease-out lg:mt-28 lg:grid-cols-12 lg:gap-16 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
          <div className="lg:col-span-5">
            <div className="relative">
              <p className="mt-4 font-default text-xs uppercase tracking-[0.2em]" style={{
              color: "var(--muted-foreground)"
            }}>
                Protection Island National Wildlife Refuge
              </p>
            </div>
          </div>

          
          <div className="lg:col-span-7">
            <div className="max-w-2xl space-y-8">
              
              <p className="text-lg leading-[1.7] text-foreground/85" style={{
              color: "var(--foreground)"
            }}>
                <span className="float-left mr-3 mt-1 font-default text-[5.5rem] leading-[0.85] text-primary" style={{
                fontFamily: "var(--font-default)",
                color: "var(--primary)"
              }}>
                  F
                </span>
                riends of the Refuges was established with a singular, unwavering purpose: to inform the public on how to protect our wildlife and sea bird refuges. From the rugged cliffs of Dungeness to the protected nesting grounds of Protection Island, our mission is to ensure these vital ecosystems remain undisturbed for generations to come.
              </p>

              
              <div className="my-12 border-y py-8 text-center" style={{
              borderColor: "var(--border)"
            }}>
                <p className="font-default text-2xl italic leading-snug md:text-[1.5rem]" style={{
                fontFamily: "var(--font-default)",
                color: "var(--primary)"
              }}>
                  "We are the voice for those who cannot speak for themselves."
                </p>
              </div>

              
              <p className="text-lg leading-[1.7] text-foreground/85" style={{
              color: "var(--foreground)"
            }}>
                Our advocacy is rooted in deep scientific understanding and a profound respect for the natural world. We believe that education is the most powerful tool for conservation. By providing the public with clear, actionable information, we empower every visitor to become a steward of our precious coastal wildlife.
              </p>

              
              <p className="text-lg leading-[1.7] text-foreground/85" style={{
              color: "var(--foreground)"
            }}>
                Today, we continue to bridge the gap between scientific research and public awareness. Whether through guided educational programs or community-led conservation efforts, our commitment remains as steadfast as the tides that shape our refuges.
              </p>

              
              <div className="pt-2">
                <p className="font-default text-3xl italic" style={{
                fontFamily: "var(--font-default)",
                color: "var(--primary)"
              }}>
                  The Advocacy Team
                </p>
              </div>
            </div>
          </div>
        </div>

        
        <div ref={timelineRef} className={`mt-24 transition-all duration-1000 ease-out lg:mt-32 ${timelineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative">
            <div className="absolute left-0 right-0 top-1/2 h-px -translate-y-1/2" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.4
          }} aria-hidden="true" />
            <div className="relative -mx-6 overflow-x-auto px-6 md:mx-0 md:overflow-visible md:px-0">
              <div className="grid min-w-[640px] grid-cols-4 gap-6 md:min-w-0">
                {milestones.map((milestone, i) => <div data-index={i} key={milestone.year} className="relative flex flex-col items-center text-center">
                    <p className="font-default text-3xl md:text-4xl" style={{
                  fontFamily: "var(--font-default)",
                  color: "var(--primary)"
                }}>
                      {milestone.year}
                    </p>
                    <div className="my-4 h-3 w-px" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                    <p className="font-default text-xs uppercase tracking-[0.2em] text-foreground">
                      {milestone.label}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div className="pointer-events-none absolute -bottom-8 -right-12 select-none overflow-hidden md:-bottom-16 md:-right-20 lg:-bottom-24 lg:-right-32" aria-hidden="true">
        <p className="font-default text-[18vw] font-light leading-none tracking-tight md:text-[16vw] lg:text-[14vw]" style={{
        fontFamily: "var(--font-default)",
        color: "var(--card)",
        opacity: 0.5
      }}>
          REFUGES
        </p>
      </div>
    </section>;
}